module.exports = __webpack_public_path__ + "static/img/icon_ice_bg@2x.ac2a501c.png";